import {api} from '@bitstillery/common/app'
import {pathname_from_location, query_string_from_location} from '@bitstillery/common/lib/env'

import {$s} from '@/app'

async function location_change() {
    if ($s.identity.token) {
        // If people go to the empty page, set the value to '/' to make it more explicit.
        let pathname = pathname_from_location(window.location)
        const query_string = query_string_from_location(window.location).toString()
        if (query_string) {
            pathname = `${pathname}?${query_string}`
        }

        await api.post('portal/activity', {page: pathname}, true)
    }
}

export async function init() {
    if (!globalThis.__SSR_MODE__) {
        window.addEventListener('locationchange', function () {
            void location_change()
        })
        // Do an initial activity track on page load.
        await location_change()
    }
}
